import image1 from "../../../assets/Images/1.jpg";

// Guides profile pic
import fatima from "../../../assets/Images/Guides/Fatima.jpg";
import haval from "../../../assets/Images/Guides/Haval.png";
import harbi from "../../../assets/Images/Guides/Harbi.png";
import nuha from "../../../assets/Images/Guides/Nuha.webp";
import yousif from "../../../assets/Images/Guides/Yousif.png";
import aliH from "../../../assets/Images/Guides/AliHameed.png";
import lubna from "../../../assets/Images/Guides/Lubna.png";
import hussein from "../../../assets/Images/Guides/Hussein Rashid.png";

// Guides Cover
import sky from "../../../assets/Images/Guides/CoverPhoto/Sky.jpeg";
import camping from "../../../assets/Images/Guides/CoverPhoto/camping.jpeg";
import basrah from "../../../assets/Images/Guides/CoverPhoto/Basrah.jpeg";
import baghdad from "../../../assets/Images/Guides/CoverPhoto/Baghdad.jpeg";
import karbala from "../../../assets/Images/Guides/CoverPhoto/Karbala.jpeg";
import najaf from "../../../assets/Images/Guides/CoverPhoto/Najaf.jpeg";
import kurdistan from "../../../assets/Images/Guides/CoverPhoto/Kurdistan.jpeg";
import anbar from "../../../assets/Images/Guides/CoverPhoto/Anbar.jpeg";

const GuideData = [
	// 1 Fatima
	{
		idGuide: 1,
		image: fatima,
		imgCover: sky,
		name: "فاطمە ئەحمەد",
		province: " بەغداد ",
		perHour: "20",
		rate: 4,
		noOfReviews: 15,
		Quote:
			"هیواداری بەرەزی یارمەتییان بەدست بیانیان یارمەتیەكانیان چاکی بیانیان چاک بەیانیان",
		ProgramsData: [
			{
				id: 101,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 102,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 103,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 104,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 1001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"فاطما ڕاهنمایەکانی تایبەتی و دانایی بەپێی عیراق پێشکەش کرد. ئەم ڕاهنما دانایە، پەیوەندیدانیە و ئەم تایبەتییە چیاکی ویژەیی دا. خوازراوەتان داواکراو بە خدمەتکردنیان.",
			},
			{
				userId: 1002,
				userName: "ئێما ڕاویس",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی فاطما داواکراوی سەرەتایی بۆ سەیری عیراق کرد. ئەو پزیشکی زانیاریی ڕووداو و یەکێکراوی گرێچکی، لەگەڵ هاوسەری گرێچکێک، تایبەتییەکی بەیادبوو. بۆ پاشنیاری فاطما و پاراستنیان ویژەیە و بەشی ئاگری دەکرێتم.",
			},
			{
				userId: 1003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"فاطما هەر دوای سەیریمان بۆ عیراق ڕاهنمایییکی ئامێر بوو. هەرچۆنێکی سەیری خۆمان بوو، لە هاوپەیمان کەلکی بەرزەر بوو و پیشکەشی بەشێوەی ڕاگیراو بوو. ڕاستیش بەریتان مانیا و چیرۆکەکانی ئاینیش لە ژیانی ناوەند پێشکەشیمان بەهیما.",
			},
			{
				userId: 1004,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"فاطما هەر دوای سەیریمان بۆ عیراق ڕاهنمایییکی ئامێر بوو. هەرچۆنێکی سەیری خۆمان بوو، لە هاوپەیمان کەلکی بەرزەر بوو و پیشکەشی بەشێوەی ڕاگیراو بوو. ڕاستیش بەریتان مانیا و چیرۆکەکانی ئاینیش لە ژیانی ناوەند پێشکەشیمان بەهیما.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من فاطمە، ڕاهنماییتانم لە چەمچەمانی بەغدا. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", "، ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
				],
			},
		],
	},
	// 2 Haval
	{
		idGuide: 2,
		image: haval,
		imgCover: camping,
		name: "هافال",
		province: " هەولێر ",
		perHour: 60,
		rate: 5,
		noOfReviews: 10,
		Quote:
			"عێراق: لە هەر قەدەمەکەیەك تاریخ لە ژیان بریان دەکات",
		ProgramsData: [
			{
				id: 201,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 202,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 203,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 204,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 2001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"هه فال پێشکەشی تایبەتی و ڕاوبەراندنەوەی گەیشتنی ئیراق داواکرا. ئەم ڕاهنمایەکە زانیاری، پەیوەندیدانی و خوشحال بوو و پەیشاندنەوەی تایبەتییەکان. خوازراوەتان داواکراوە و خزمەتکردنیان بەشی زۆری پێشنیار داکاتم.",
			},
			{
				userId: 2002,
				userName: "ئێما ڕاویس.",
				userGuideRate: 5,
				comment:
					"هه فال پێشکەشی بوەستەکردنمان بۆ عیراق هەڵسەنگاند. زانیاریی ڕووداو و دیاری بەرز لە سەرچاوە و یەکێکراوی گرێچکی، لەگەڵ یەکێکدانی تایبەتییەکی گەرم و پێشاندان، تایبەتییەکی بەیادبوو دابوەش. سوپاسمان بە هاول به‌رهێنی به‌شی پارێزگاکراویان بە ویژەیی و بە شێوەیەکی پێشنیاریان بیشکرینم.",
			},
			{
				userId: 2003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"هه‌فال ڕاهنمایییمان بوو لەکاتی گەیشتنمان بۆ عیراق. هەرچۆنێکی سەیری خۆمان بوو، پەیوەندیدانی و پیشکەشی بەرزەر بوو و لەهەریمان زانیارییەکانی تایبەتییەکان پێشاندان. هەرچەنێکی چاکبەرنامە، مەبەستیەکانی هه‌فال لەچەند جوانەر بوون، پەیشاندانمان بەپیشە خۆیەکان و هەریمان ڕۆژخەڵات. سوپاسمان بۆ هەوڵدانەکان و دانیشتنیان لەسەر ژیانی ناوەند.",
			},
			{
				userId: 2003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"هه‌فال ڕاهنمایییمان بوو لەکاتی گەیشتنمان بۆ عیراق. هەرچۆنێکی سەیری خۆمان بوو، پەیوەندیدانی و پیشکەشی بەرزەر بوو و لەهەریمان زانیارییەکانی تایبەتییەکان پێشاندان. هەرچەنێکی چاکبەرنامە، مەبەستیەکانی هه‌فال لەچەند جوانەر بوون، پەیشاندانمان بەپیشە خۆیەکان و هەریمان ڕۆژخەڵات. سوپاسمان بۆ هەوڵدانەکان و دانیشتنیان لەسەر ژیانی ناوەند.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من هەول، ڕاهنماییتانم لە چەمچەمانی ھەولێر. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", ", كوردي ", ", ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 3 Harbi
	{
		idGuide: 3,
		image: harbi,
		imgCover: basrah,
		name: "هه‌ربی عه‌دل",
		province: " بازرە",
		perHour: 30,
		rate: 5,
		noOfReviews: 5,
		Quote:
			"چونەچمنی حیوانتکاری بکە، چەندێ ڕوویدا لەرۆژه‌ یەکگرتووی عێراق",
		ProgramsData: [
			{
				id: 301,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 302,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 303,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 304,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 3001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"هه‌ربی پێشکه‌شی و سه‌رتایی به‌رز ئێراق دان. ئەم ڕاژەکارە ئەرشیفێکی هیوایی، هاوڕێم و هەمیشە تایبەت کرا. هیشتاوی خۆشەویستنیمان زۆر باش دەکات. خزمەتیان بەهێزی پیشنیار دەکەم.",
			},
			{
				userId: 3002,
				userName: "ئێما چاڤیس",
				userGuideRate: 5,
				comment:
					"راهنمایی هه‌ربی هه‌رسۆ زیاتربووانی سەردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی هه‌ربی خۆشحاچە و بەرهەم دەکات و خاڵی پێشنیار دەکات بەراهەمان.",
			},
			{
				userId: 3003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"هه‌ربی ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، هه‌ربی کۆمه‌ڵێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 3003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"هه‌ربی ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، هه‌ربی کۆمه‌ڵێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من حربی، ڕاهنماییتانم لە چەمچەمانی بصرا. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", "، ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 4 Nuha
	{
		idGuide: 4,
		image: nuha,
		imgCover: baghdad,
		name: "نوهه م",
		province: " بەغداد ",
		perHour: 50,
		rate: 5,
		noOfReviews: 4,
		Quote: "سه‌رۆکای هەزار چیرۆک، گه‌شتی بۆ عێراق",
		ProgramsData: [
			{
				id: 401,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 402,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 403,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 404,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 4001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"نوحە ڕاهنمایییەکی تایبەت و سه‌رتایی به‌رز ئێراق دان. ئەم ڕاژەکارە زانیاری، هاوڕێم و هەمیشە تایبەت کرا. هیشتاوی خۆشەویستنیمان زۆر باش دەکات. خزمەتیان بەهێزی پیشنیار دەکەم.",
			},
			{
				userId: 4002,
				userName: "ئێما چاڤیس",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی نوحە هه‌رسه‌ر زیاتربووانی سەردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی نوحە خۆشحاچە و بەرهەم دەکات و خاڵی پیشنیار دەکەم بەراهەمان.",
			},
			{
				userId: 4003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"نوحە ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، نوحا کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 4003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"نوحە ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، نوحا کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من نوها، ڕاهنماییتانم لە چەمچەمانی بەغدا. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", ", ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 5 Yousif
	{
		idGuide: 5,
		image: yousif,
		imgCover: karbala,
		name: "یوسف ئەل‌فهاد",
		province: " که‌ربه‌له ",
		perHour: 80,
		rate: 5,
		noOfReviews: 10,
		Quote:
			"هەژمارەکەی ڕووداوی که‌ربه‌له، چەندین ڕاهبەرانیەکانی ژیانی گۆڕاو",
		ProgramsData: [
			{
				id: 501,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1705698000",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 502,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1703538000",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 503,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1644008400",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 504,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1707080400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 5001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"یوسف ڕاهنمایییەکی تایبەت و سه‌رتایی به‌رز ئێراق دان. ئەم ڕاژەکارە زانیاری، هاوڕێم و هەمیشە تایبەت کرا. هیشتاوی خۆشەویستنیمان زۆر باش دەکات. خزمەتیان بەهێزی پیشنیار دەکەم.",
			},
			{
				userId: 5002,
				userName: "ئێما چاڤیس",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی یوسف هه‌رسه‌ر زیاتربووانی سەردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی یوسف خۆشحاچە و بەرهەم دەکات و خاڵی پیشنیار دەکەم بەراهەمان.",
			},
			{
				userId: 5003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"یوسف ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری یوسفی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 5003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"یوسف ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری یوسفی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من یوسف، ڕاهنماییتانم لە چەمچەمانی کەربڵا. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", ", كوردي ", ", ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 6 Ali
	{
		idGuide: 6,
		image: aliH,
		imgCover: najaf,
		name: "عەلی حمید",
		province: " بەغداد ",
		perHour: "20",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"به‌شی سه‌فر بۆ عێراق، که‌ لای ڕووداوێکدا گرنگ و پشوو بەرز ئێراقیان",
		ProgramsData: [
			{
				id: 601,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1717966800",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 602,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 603,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1675544400",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 604,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1734296400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 6001,
				userName: "داڤید جۆنسن",
				userGuideRate: 4,
				comment:
					"عه‌لی ڕاهنمایییه‌کی تایبه‌ت و سه‌رتایی به‌رز ئێراق دان. ئه‌م ڕاژه‌کاره‌ زانیاری، هاوڕێم و هەمیشه‌ تایبه‌ت کرا. هیشتاوی خۆشەویستنیمان زۆر باشه‌. خزمه‌تیان به‌هیزی پیشنیار ده‌که‌م.",
			},
			{
				userId: 6002,
				userName: "ئێما چاڤیس",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی عه‌لی هه‌رسه‌ر زیاتربووانی سه‌ردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی عه‌لی خۆشحاچە و بەرهەم دەکات و خاڵی پیشنیار دەکەم بەراهەمان.",
			},
			{
				userId: 6003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"عه‌لی ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری عه‌لی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 6003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"عه‌لی ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری عه‌لی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من عەلی، ڕاهنماییتانم لە چەمچەمانی بەغدا. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", ", كوردي ", ", ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 7 Lubna
	{
		idGuide: 7,
		image: lubna,
		imgCover: kurdistan,
		name: "لوبنا صادق",
		province: "سلێمانی",
		perHour: "40",
		rate: 3.5,
		noOfReviews: 13,
		Quote:
			"تایبه‌تی هاورێی عێراقیەکان بەکارهێنه‌، یه‌کێ به‌رێز بۆ سه‌فری تایبه‌تی",
		ProgramsData: [
			{
				id: 701,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1659474000",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 702,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1701550800",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 703,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1696885200",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 704,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1686344400",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 7001,
				userName: "David Johnson",
				userGuideRate: 4,
				comment:
					"لوبنا ڕاهنمایییەکی تایبەت و سه‌رتایی به‌رز ئێراق دان. ئه‌م ڕاژه‌کاره‌ زانیاری، هاوڕێم و هەمیشه‌ تایبه‌ت کرا. هیشتاوی خۆشەویستنیمان زۆر باشه‌. خزمه‌تیان به‌هیزی پیشنیار ده‌که‌م.",
			},
			{
				userId: 7002,
				userName: "ئێما چاڤیس",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی لوبنا هه‌رسه‌ر زیاتربووانی سه‌ردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی لوبنا خۆشحاچە و بەرهەم دەکات و خاڵی پیشنیار دەکەم بەراهەمان.",
			},
			{
				userId: 7003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"لوبنا ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری لوبنای کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 7003,
				userName: "مایکل سمیت",
				userGuideRate: 3,
				comment:
					"لوبنا ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری لوبنای کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من لوبنا، ڕاهنماییتانم لە چەمچەمانی سلێمانیە. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی", ", كوردي ", ", ئینگلیزی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
	// 8 Hussein
	{
		idGuide: 8,
		image: hussein,
		imgCover: anbar,
		name: "حسین ڕاشید",
		province: " ئانبار ",
		perHour: "15",
		rate: 5,
		noOfReviews: 10,
		Quote:
			"عێراق، موزاییکێک لە مەنەجاندنەوە کە چاوەڕوان بەکرێت.",
		ProgramsData: [
			{
				id: 801,
				image: image1,
				name: "چیاچاوەکانی میسۆپاتامیا",
				describe:
					"ڕازی چیاچاوەکان و شاهزادەکانی هەندی قدیمی یاساکانی میسۆپاتامیا",
				cost: 370,
				duration: 3,
				startDate: "1703019600",
				schedule: {
					day1: {
						title: "هاتن و کردنی گه‌شت و ڕاستیدان",
						activities: [
							"لە ناوه‌ندی په‌یماندای چاککردنەوه‌ ده‌ستیاربکات.",
							"به‌شداری بكه‌ بە هاوڕێكانی گه‌لبه‌رێکیت و په‌یماندایت.",
							"کارده‌ست بکه‌ بۆ ڕاستیدان بە شێوەیەکی پەیماندایی.",
							"سه‌ردانی پارچێکانی گه‌یشتنی هه‌ندی.",
							"بچووکراو بیڤاندنەتیشییه‌کەت له‌ ده‌ست به‌رگیت.",
						],
					},
					day2: {
						title: "تجربەیی گەلی ناوی هونەری",

						activities: [
							"چاکی دووەم وەھیدا یەکێک لە تایبەتە ناوی هونەری دەبێت کاتێک دەست بەرزتێت لە گەیشتنی ڕازی تاریخی میسۆپاتامیا.",
							"بەشداریبە هەموو چالاکیەکانی هونەری و تجربەییەکان، دەربارەی هەرێمیانەوە پەیڕەوە دەبینیت لە برێکدا.",
							"ئەم ڕۆژە چارەسەری پەیوەندیدان بە جیاوازی هاوسەرانی ناوەندییەکان، بەرزیتێ دەبینیت لە دەربارەی مێژووی پارێزگاکە کە پێوەراوت دەکات.",
						],
					},
					day3: {
						title: "دونیای تازەکان و فەرمیاندن",
						activities: [
							"لە ڕۆژی کۆتایی سەرکەوتوشتی گەیشتنی خۆشەویستیت، هەر ڕووداوەکانی هەندی تایبەتی دیاربکەوە، دژیتن بە هەرێمی چیاچاوەکانی ڕووبەراندا.",
							"کاتی بگرە بۆ پڕی کردنەوەی زیاڤەیەکی کە میسۆپاتامیا چێشتیان بەشێوەیەکی.",
							"گەیشتن خەتەکە باسە، لەو خوارەوە ڕووبەرەندایەکی پەیوەندیدان، چیاچاوەکانتان دەرکەوتەیی دەگات.",
							"پاشان، دەرکەوت بەسەر بۆ گەیشتنی پارێزەیتان، خاوەنی یادکراوەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
				},
			},
			{
				id: 802,
				image: image1,
				name: "گەیشتنی کوردی",
				describe:
					"لە هەرێمە کوردیەکە دەربڕین بکە لە ناوی هونەری پارلەمان و چیاچاوەی گوند و قەڵاییی زۆر و شازادەیان بیانیەوە.",
				cost: 400,
				duration: 4,
				startDate: "1729026000",
				schedule: {
					day1: {
						title: "هاتن و پاراستن",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن.",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمە کوردیەکەت دەستپێش بکە.",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "ئیمرسییە کەلتووری",
						activities: [
							"گەیشتنی خۆشمەژێکی تاریخی پارێزگایی پەیشبکە.",
							"بەشداربوون لە چالاکیەکان و تجربەییەکانی هونەر.",
							"پەیوەندیدان بە هاوسەرانی ناوەندی و ژیانیانیان بەشێوەیی گەیشەن و ڕاستیدانیانیان بەگۆڕێ.",
						],
					},
					day3: {
						title: "طبیعەت و سەرمایە",
						activities: [
							"چاک بکە لە جوڵانی طبیعی یەکێکەتانی کوردیەکان",
							"بەشداربوون لە چالاکیەکانی هه‌ریمەندا و هاوەرەیەکان.",
							"زیاتری سوتان بەبێ دانیشتنی هەریمەندایەکی تایبەتی و فرهنگی ناوەند.",
						],
					},
					day4: {
						title: "خەتم و چوونەژوورەوە",
						activities: [
							"گەیشتنی خۆشمەژێکی خەتمی بکە بە چوونەژووری",
							"بۆ گەیشتنی پارێزگایتان بڕۆ بەرگی یادکراوی گەیشتنی کوردی",
						],
					},
				},
			},
			{
				id: 803,
				image: image1,
				name: "گەیشتنی وارثی بەغداژ",
				describe:
					"درێژبوونی چیاچاوەکانی تاریخی و فرهنگی ھەڵبژاردنی پایتەختی عێراق",
				cost: 200,
				duration: 4,
				startDate: "1733173200",
				schedule: {
					day1: {
						title: "هاتن و ڕاستی دان",
						activities: [
							"لە ناوەندی پێشپەیجی داخستن",
							"ئیشکراویت با هاوسەرانیت و چاوپێشیت.",
							"بەرزترین چاک کردنی هەرێمەی چیاچاوەکانی گەڕمی دەستپێش بکە.",
							"سەردانی پارچێکانی گەیشتنی هەندی",
							"شێوازی سوپاسی خۆش زۆربکە.",
						],
					},
					day2: {
						title: "تجربەی فرهنگیی گەشی",
						activities: [
							"پارلەمان گەیشتنت چاکەکانی تاریخی میسۆپاتامیا.",
							"بەشداربوون لە چالاکیەکانی فرهنگی و تجربەییەکان.",
							"پەیوەندیدان بە هاوسەرانی ناوەند، چیاچاوەکانیان بەشی زیاتری دانان لە پارێزگای داخلیەکەتان.",
						],
					},
					day3: {
						title: "دیاریەکانی کۆتایی و چوونەژوورەوە",
						activities: [
							"هەر رووداوەکانی هەندی چیاچاوەی دیاربکەوە، هەرمێیاندا نموونەکانی گەیشتنی ڕازی گیراوند.",
							"کاتێک بگرە بۆ شێوازی خۆشیاری کە میسۆپاتامیا پیشکەش دەکات.",
							"گەیشتن خەتمی بکە بە چوونەژووریەکی باس، کەتایەک بە ئەنجام دانانی چاک بکە.",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان، یادەکانی میسۆپاتامیا لەگەڵت بچێوە.",
						],
					},
					day4: {
						title: "چوونەژوورەوە",
						activities: [
							"لە هاوسەرخانەکەتان چێک ئەکاتەی.",
							"سەنتەرچاویەکان و یادەکانی درێژکراوەکانتان بنێرە",
							"چوونەژوورەوە بۆ گەیشتنی پارێزگایەکەتان.",
						],
					},
				},
			},
			{
				id: 804,
				image: image1,
				name: "ئایینەی ئاسایی چایەنەکان",
				describe:
					"به‌رزتن لە خۆشیارییەکانی تایبەتی چایەنەکانی عێراق، تازیاندنەوەی ڕووبەراندایەکی تایبەتی و فرهنگیی ناوەند",
				cost: 200,
				duration: 2,
				startDate: "1681938000",
				schedule: {
					day1: {
						title: "هاتن و ئیمرسییەی طبیعەت",
						activities: [
							"لەناو هەنگاوێکی تایبەتی چایەنەکان بەرز بکەوە.",
							"لە هاوسەرخانەی خۆشگایەکانیتان چێک ئەکەین.",
							"به‌رز بنێرە لە طبیعەت بە گشتی لە گەڕمی.",
							"بەشداربوون لە یەکێک لە سیشۆنەکانی ئایینەیی بۆ ئەرەزیش و ڕەقەبەتی بەشی تازە.",
							"شێوازی چێشتی بەشێوەیی دواخۆ بکەوە.",
						],
					},
					day2: {
						title: "به‌رز و چوونەژوورەوە",
						activities: [
							"بە ڕووژێکی نوێ بە یۆگایەکە پارلەمانی چایەنەکان دەستپێش بکە",
							"لە چاکی گەڕمی تایبەتی بەشی چاک کردنەوە بۆ ڕووژەکەتان دەستپێش بکە.",
							"تجربە یەکەمی سیپا یان ماساژ بۆ ئارامیشی نیشانی تەواو.",
							"بەشداربوون لە یەکێک لە گشتی فەتۆگرافی یان چاکی شینەکان.",
							"بە چاک بکەوە بەشی گەورە بۆ چاکی تایبەتی.",
							"چێک ئەکاتەی لە چاک بکەوە و چوونەژوورەوە بە حسەی ئارامیشتی و جیانی نوێکراو.",
						],
					},
				},
			},
		],
		UsersReviews: [
			{
				useId: 8001,
				userName: "سمیت جۆنسن.",
				userGuideRate: 3.5,
				comment:
					"حسین ڕاهنمایییەکی تایبەت و سه‌رتایی به‌رز ئێراق دان. ئه‌م ڕاژه‌کاره‌ زانیاری، هاوڕێم و هەمیشه‌ تایبه‌ت کرا. هیشتاوی خۆشەویستنیمان زۆر باشه‌. خزمه‌تیان به‌هیزی پیشنیار ده‌که‌م.",
			},
			{
				userId: 8002,
				userName: "ئێما واتسۆن",
				userGuideRate: 5,
				comment:
					"ڕاهنمایی حسین هه‌رسه‌ر زیاتربووانی سه‌ردانیم بۆ عێراق. زانیاری ژێرنووس و هه‌رچاوەتی زانیاری، هاوسه‌رخۆشبوویەکانی زۆرەکێشی، سه‌رنجه‌مه‌ندنییەکانی یەکگرتوویە. بەپێی زانستەکانی حسین خۆشحاچە و بەرهەم دەکات و خاڵی پیشنیار دەکەم بەراهەمان.",
			},
			{
				userId: 8003,
				userName: "مورفی کریس",
				userGuideRate: 2,
				comment:
					"حسین ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری حسینی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
			{
				userId: 8003,
				userName: "مورفی کریس",
				userGuideRate: 2,
				comment:
					"حسین ڕاهبەریمان بەرز ئێراق دان. هەر چێشت بوو، ڕاهبەری حسینی کۆمەژێک و بەرێزترینی خزمەتگوزاری لە ڕاگەیاند. گرنگی چەند تاک و چوار، ئێمە پیشاند و هاوسەرخۆش و دانیشتیەکانی تایبەتیان پارێزراو.",
			},
		],
		GuideInfo: [
			{
				title: "من بەرز توانمە بەکاربهێنم",
				description:
					"توانای ئەزموونی دڵنیایی یانگەکان، نیشانە نمای ئایینی، گوێ بوەستنی چەمچەمانی عیراقی و گەڵەکانی فرۆشگایی لەگەڵ من",
			},
			{
				title: "دەربارەی من",
				description: `سڵاو، من حەسەین، ڕاهنماییتانم لە چەمچەمانی ئەنبار. چاک بکە بۆ یەکێک لە خولیگی سەرمایی و خۆشبختییەکانی فرۆشی تاریخی و ئەندامانی فرۆشگایی`,
			},
			{
				title: "زمانەکان",
				description: ["عەرەبی"],
			},
			{
				title: "چاکسازیەکان",
				description: [
					"گواستنەوەی تاریخی",
					"، خولیخۆشی چەمچەمانی",
					"، گواستنەوەی بازار",
					"، چاکسازیەکانی گوێژی",
					"، کەمپینگ",
				],
			},
		],
	},
];

export default GuideData;
